import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DataService } from '../data.service';
import { EtlapHetiComponent } from '../components/etkezes-etlap/etlap-heti.component';

/**
 *  ÉTLAP (/etlap) – olvasó nézet, elsősorban a TANULÓNAK.
 *
 *  Az Étkezés képernyő a rendelés felülete: be-/kilépés, napok kérése, mentés. A tanuló
 *  nem rendel (a gondviselő vagy az iskola teszi), viszont tudni szeretné, mi lesz az
 *  ebéd. Ha az Étkezés képernyőt kapná meg, a rendelő gombokat is megkapná – ezért kap
 *  külön, csak olvasható oldalt. Bárki megnyithatja, akinek a menüben szerepel.
 */
@Component({
  selector: 'app-etlap',
  standalone: true,
  imports: [CommonModule, IonicModule, EtlapHetiComponent],
  template: `
    <ion-header [translucent]="true">
      <ion-toolbar color="primary">
        <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
        <ion-title>Étlap</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="etlap-lap">
        <p class="etlap-bevezeto">Mit főz a konyha a héten, menünként. A nyilakkal a korábbi és a következő hetek is megnézhetők.</p>
        <app-etlap-heti *ngIf="intezmeny" [intezmeny]="intezmeny" cim="Heti étlap"></app-etlap-heti>
        <p class="etlap-bevezeto" *ngIf="!intezmeny && betoltve">Nem azonosítható az intézmény.</p>
      </div>
    </ion-content>
  `,
  styleUrls: ['../components/etkezes-etlap/etlap.component.scss'],
})
export class EtlapComponent implements OnInit {
  intezmeny = '';
  betoltve = false;

  constructor(private data: DataService) {}

  async ngOnInit() {
    const sajat = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(sajat?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    this.betoltve = true;
  }
}
